import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { APICONSTANTS } from '../constants';
import { HttpClientService } from './http.client.service';
import { IListResponse, IResponse } from '../interfaces/http-interface';
import { IAdaptedSearchProviderResponse, IFacilityAssociatedPhysicians, IFetchLocationResponse, IListProviderBundles, IPhysicianAssociatedFacilitiesResponse, ISearchProviderResponse } from '../interfaces';
import { adaptProviderBundlesResponse, adaptSearchProviderResponse } from '../utils/provider.utils';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  providerExportQuery: any = {};

  constructor(private _http: HttpClientService) { }

  getNetworkConfigs(networkCode) {
    return this._http.get(`${APICONSTANTS.NETWORKS}/${networkCode}`).pipe(
      map((response: any) => {
        return response;
      })
    );
  }



  getBundles(query?: any) {
    return this._http
      .get(`${APICONSTANTS.BUNDLES}/autocomplete`, {
        ...query,
        associatedWithProviderOnly: true,
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  getProviders(query?: any) {
    return this._http.get(`${APICONSTANTS.PROVIDERS}/autocomplete`, query).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  searchProviders(query?: any) {
    return this._http.get(`${APICONSTANTS.NETWORK_OFFERINGS}`, query).pipe(
      map((response: IResponse<IListResponse<ISearchProviderResponse>>): IResponse<IListResponse<IAdaptedSearchProviderResponse>> => {
        return {
          ...response,
          data: {
            ...response.data,
            rows: response.data.rows.map((item: ISearchProviderResponse) => adaptSearchProviderResponse(item))
          },
        }
      })
    );
  }

  getPhysicianDetail(facilityId, query?: any) {
    return this._http
      .get(`${APICONSTANTS.PROVIDERS}/${facilityId}/physicians`, query)
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  getFacilityDetail(facilityId, query?: any) {
    return this._http
      .get(`${APICONSTANTS.PROVIDERS}/${facilityId}/facilities`, query)
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  getServicesDetail(query?: any) {
    return this._http
      .get(`${APICONSTANTS.PROVIDERS}/autocomplete`, {
        keyword: 'aspen',
        networks: 'HPS',
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  getCategories(query?: any) {
    return this._http.get(`${APICONSTANTS.CATEGORIES}`, query).pipe(
      map((response: any) => {
        return response;
      })
    );
  }


  getFacilityPhysicians(facilityCode, query?: any) {
    return this._http.get(`${APICONSTANTS.FACILITY_PHYSICIANS.replace(':facilityCode', facilityCode)}`, query).pipe(
      map((response: IResponse<IListResponse<IFacilityAssociatedPhysicians>>) => {
        return response;
      })
    );
  }


  getPhysicianFacilities(physicianCode, query?: any) {
    return this._http.get(`${APICONSTANTS.PHYSICIAN_FACILITIES.replace(':physicianCode', physicianCode)}`, query).pipe(
      map((response: IResponse<IListResponse<IPhysicianAssociatedFacilitiesResponse>>) => {
        return response;
      })
    );
  }

  getAssociatedBundles(providerCode, query?: { networkCode?: string }) {
    return this._http.get(`${APICONSTANTS.ASSOCIATED_BUNDLES.replace(':providerCode', providerCode)}`, query).pipe(
      map((response: IResponse<IListResponse<IListProviderBundles>>) => {
        return {
          ...response,
          data: {
            ...response.data,
            rows: response.data.rows.map((item: IListProviderBundles) => adaptProviderBundlesResponse(item))
          },
        }
      })
    );
  }

  exportProviders(query?: Record<string, any>) {
    return this._http.getBlob(`${APICONSTANTS.EXPORT_PROVIDERS}`, {
      ...this.providerExportQuery,
      ...query,
    });
  }

  exportProviderFacilityReport(query?: Record<string, any>) {
    return this._http.get(`${APICONSTANTS.EXPORT_PROVIDER_FACILITY_REPORT}`, {
      ...this.providerExportQuery,
      ...query,
    });
  }
}
